import React, { useEffect, useState } from 'react'
//import { useSearchParams } from 'react-router-dom'
import { postDataUserEliminarUnProcedimiento, postEliminarProcedimientoTODO, postEliminarUpdateProcedimiento, postUpdateHCCOM5yHCCOM51 } from '../../../services/PaginaRuta'
import { HoraActual, fechaActual } from '../../../hooks/UseDate'

const ModalEliminarProcedimiento = ({setmodalOnEliminarUnProcedimiento, item, passCancelarSesion, passConfirmarEliminar}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [dataUserEliminar, setdataUserEliminar]=useState([])
  const [fechaProcedimiento, setfechaProcedimiento]=useState('')
  const [errorMotivoCancelacion, seterrorMotivoCancelacion]=useState('')
  const [textAreaMotivo, settextAreaMotivo]=useState('')
    const handleCancelarClick=()=>{
      setmodalOnEliminarUnProcedimiento(false)
    }

    const handleOnsubmitEliminar=(e)=>{
      e.preventDefault();
      const bodyEliminar={
        varProEmpCod:usuarioInfo.Empresa,
        varProMCDpto:usuarioInfo.Sede,
        varProCirCod:item.ProCirCod,
        varCrgCod:item.CrgCod
      }
      

      

      const updateHCCOM51yHCCOM5 =  {
        "HISCKEY": e.target.pacienteCedula.value,
        "HISTipDoc": dataUserEliminar.MPTDoc,
        "HCPrcCns": "1",
        "HCPrStGr":"C",
        "HCPrcEst":"C",
        "HCPrcHrRe": `${fechaActual()} ${HoraActual()}`,//"2023-09-13 18:55:55.000",
        "HCFcHrAp": `${fechaActual()} ${HoraActual()}`,//"2023-09-13 18:55:55.000",
        "CodEmpCod":usuarioInfo.Empresa,
        "CodMcdpto":usuarioInfo.Sede,
        "HCProCir":item.ProCirCod,
        "CodCir":item.ProCirCod,
        "HCPrcCod":item.CrgCod
    }

  
    console.log(updateHCCOM51yHCCOM5,'antes HCCOM5yHCCOM51')

      if(errorMotivoCancelacion==''){

        postUpdateHCCOM5yHCCOM51(updateHCCOM51yHCCOM5).then((res)=>{
          console.log(res,'se modifico HCCOM5yHCCOM51')
        }).catch(error => {
      
          
        });
        
        postEliminarProcedimientoTODO(bodyEliminar).then((res)=>{
          console.log(res,'eliminoooo')
          passConfirmarEliminar(bodyEliminar)
        }).catch((error) => {
          //console.error('Error al autenticar al usuario:', error);
          //seterrorEndpoint(true);
          //setLoading(true);
        });
        // postEliminarUpdateProcedimiento(bodyUpdate).then((res)=>{
        //   console.log(res,'eliminoooo update')
        //   passConfirmarEliminar(bodyUpdate)
        // })        
        setmodalOnEliminarUnProcedimiento(false)
        //passConfirmarEliminar(bodyUpdate)
        passCancelarSesion(bodyEliminar)
        
      }
    }

    useEffect(()=>{
      console.log(item,'item item')
      const body={
        vaProEmpCod:usuarioInfo.Empresa,
        varProMCDpto:usuarioInfo.Sede,
        varProCirCod:item.ProCirCod
      }
      //console.log(item,'itemitemitem')
      postDataUserEliminarUnProcedimiento(body).then((res)=>{
        setdataUserEliminar(res.data[0])
        //console.log(res.data,'data a eliminar')
        let fecha=res.data[0].ProFec
        let fechasplit = fecha.split(' ')
        //console.log(fechasplit,'fechaaaaaa')
        setfechaProcedimiento(fechasplit[0])
      }).catch(error => {
      
        
      });
      seterrorMotivoCancelacion('Por favor elija un motivo de cancelación válido')
    },[])

    const handleOnchange=(e)=>{
      //console.log(e.target.value)
     
      if(e.target.value == "Sin Motivo"){
        seterrorMotivoCancelacion('Por favor elija un motivo de cancelación válido')
        settextAreaMotivo('')
      }else if(e.target.value == "Administrativo"){
        seterrorMotivoCancelacion('')
        settextAreaMotivo(' EL MOTIVO DE LA CANCELACIÓN FUE DE TIPO ADMINISTRATIVO')
      }else if(e.target.value == "Paciente"){
        seterrorMotivoCancelacion('')
        settextAreaMotivo(' EL MOTIVO DE LA CANCELACIÓN FUE DE TIPO PACIENTE')
      }else if(e.target.value == "Médico"){
        seterrorMotivoCancelacion('')
        settextAreaMotivo(' EL MOTIVO DE LA CANCELACIÓN FUE DE TIPO MÉDICO')
      }
    }


  return (
    <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%-3rem)] max-w-7xl my-6 mx-auto relative w-auto pointer-events-none ">
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
              <h5
                className="text-xl font-medium leading-normal text-gray-800"
                id="exampleModalScrollableLabel"
              >
                Cancela Procedimiento 
              </h5>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <form onSubmit={handleOnsubmitEliminar}>
              <div className="flex-auto overflow-y-auto relative p-1">
                
                  
                  <div className="flex flex-row py-2  text-left">
                    <div className="w-1/4  px-2 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Empresa 
                      </label>
                      <input
                      defaultValue={dataUserEliminar.ProEmpCod}
                        //autoComplete="off"
                        type="text"
                        disabled={true}
                        //defaultValue={dataUser.ProCirCod}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-2 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Sede
                      </label>
                      <input
                      defaultValue={dataUserEliminar.ProMCDpto}
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        //defaultValue={dataUser.MPCedu}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-2 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        N° Cirugía
                      </label>
                      <input
                      defaultValue={dataUserEliminar.ProCirCod}
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        //defaultValue={dataUser.MPTDoc}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-2 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Quirófano
                      </label>
                      <input
                      defaultValue={dataUserEliminar.ProCons}
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        //defaultValue={dataUser.MPNOMC}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="flex flex-row py-2  text-left">
                    <div className="w-1/4  px-2">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Fecha Cirugía
                      </label>
                      <input
                      defaultValue={fechaProcedimiento}
                        autoComplete="off"
                        type="date"
                        disabled={true}
                        //defaultValue={dataUser.ProCirCod}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-2">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Hora Inicial
                      </label>
                      <input
                      defaultValue={dataUserEliminar.ProHorI}
                        autoComplete="off"
                        type="time"
                        disabled={true}
                        //defaultValue={dataUser.MPCedu}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-2">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Hora Final
                      </label>
                      <input
                      defaultValue={dataUserEliminar.ProHorF}
                        autoComplete="off"
                        type="time"
                        disabled={true}
                        //defaultValue={dataUser.MPTDoc}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Paciente
                      </label>
                      <input
                      defaultValue={dataUserEliminar.MPCedu}
                      name='pacienteCedula'
                        autoComplete="off"
                        type="text"
                        disabled={true}
                        //defaultValue={dataUser.MPNOMC}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                
                <h5
                  className="text-xl font-medium leading-normal text-gray-800 text-center pt-5"
                  id="exampleModalScrollableLabel"
                >
                  Motivo de Cancelación
                </h5>
                <div className="text-left pt-5">
                  <div className="w-1/4  ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      
                    </label>
                    <div className="">
                      <select
                        //defaultValue={dataDetalles.ViaCod}
                        onChange={handleOnchange}
                        className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        aria-label="Default select example"
                      >
                        <option value="Sin Motivo">Sin Motivo</option>
                        <option value="Administrativo">Administrativo </option>
                        <option value="Paciente">Paciente</option>
                        <option value="Médico">Médico</option>
                      </select>
                    </div>
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorMotivoCancelacion}
                    </label>
                  </div>
                  <div className="w-3/4 pt-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Observaciones
                      </label>
                    <textarea
                      autoComplete="off" 
                      defaultValue={textAreaMotivo} 
                      name='observaciones'                    
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                            transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      id="exampleFormControlTextarea1"
                      rows="2"
                      placeholder=""
                    ></textarea>
                  </div>
                </div>

                
              </div>
            
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                onClick={handleCancelarClick}
                className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button type="submit"
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                Eliminar
              </button>
            </div>
            </form>
          </div>
        </div>
      </div>
  )
}

export default ModalEliminarProcedimiento